import { call, takeLatest, put } from 'redux-saga/effects'
import graphql from 'services/graphql'
import api from 'services/api'
import {
  errorMessageFromGraphQL,
  successMessage,
  warningMessage,
  deletedMessage,
  savedMessage,
} from 'config/toast'
import {
  FAILED_GET_VESSEL,
  FAILED_GET_VESSELS,
  FAILED_PERSIST_VESSEL,
  FAILED_DELETE_VESSEL,
  RECEIVE_GET_VESSEL,
  RECEIVE_GET_VESSELS,
  RECEIVE_PERSIST_VESSEL,
  RECEIVE_DELETE_VESSEL,
  REQUEST_GET_VESSEL,
  REQUEST_GET_VESSEL_LIST,
  REQUEST_GET_VESSELS,
  REQUEST_PERSIST_VESSEL,
  REQUEST_DELETE_VESSEL,
} from 'redux/actions/vessel'
import { NOTIFY } from 'redux/actions/notification'
import { VESSEL_QUERY, VESSEL_LIST_QUERY, VESSELS_QUERY } from 'graphql/queries/vessel'
import { VESSEL_MUTATION } from 'graphql/mutations/vessel'

function* getVessel(action) {
  try {
    const data = yield call(graphql.query, VESSEL_QUERY, { id: action.id })

    yield put({ type: RECEIVE_GET_VESSEL, data: data.vessel })
  } catch (error) {
    yield put({ type: FAILED_GET_VESSEL, error })
    const notification = yield errorMessageFromGraphQL(error)
    yield put({ type: NOTIFY, notification })
  }
}

function* getVesselList(action) {
  try {
    const data = yield call(graphql.query, VESSEL_LIST_QUERY, {
      ...(action.filters ? { filters: action.filters } : {}),
    })

    yield put({
      type: RECEIVE_GET_VESSELS,
      data: data.vesselList,
      pageNumber: 0,
      totalCount: 0,
    })
  } catch (error) {
    yield put({ type: FAILED_GET_VESSELS, error })
    const notification = yield errorMessageFromGraphQL(error)
    yield put({ type: NOTIFY, notification })
  }
}

function* getVessels(action) {
  try {
    const data = yield call(graphql.query, VESSELS_QUERY, {
      pageNumber: action.pageNumber,
      pageSize: action.pageSize,
      ...(action.filters ? { filters: action.filters } : {}),
      ...(action.sorting ? { sorting: action.sorting } : {}),
    })

    yield put({
      type: RECEIVE_GET_VESSELS,
      data: data.vessels.data,
      pageNumber: action.pageNumber,
      totalCount: data.vessels.total,
    })
  } catch (error) {
    yield put({ type: FAILED_GET_VESSELS, error })
    const notification = yield errorMessageFromGraphQL(error)
    yield put({ type: NOTIFY, notification })
  }
}

function* persistVessel(action) {
  try {
    delete action.data.__typename
    delete action.data.company
    delete action.data.image

    action.data.description = {
      value: action.data.description?.value || '',
    }

    action.data.name = {
      value:
        typeof action.data.name === 'string'
          ? action.data.name
          : action.data.name?.value || '',
    }

    action.data.sizes = (action.data.sizes || []).map(({ id, __typename, name, ...size }) => ({
      ...(id && !String(id).startsWith('new-') ? { id } : {}),
      name: {
        value: typeof name === 'string' ? name : name?.value || '',
      },
      ...size,
    }))

    const data = yield call(graphql.mutate, VESSEL_MUTATION, action.data)

    yield put({
      type: RECEIVE_PERSIST_VESSEL,
      data: data.vessel,
    })

    const notification = successMessage(savedMessage('vessel'))
    yield put({ type: NOTIFY, notification })
  } catch (error) {
    yield put({ type: FAILED_PERSIST_VESSEL, error })
    const notification = yield errorMessageFromGraphQL(error)
    yield put({ type: NOTIFY, notification })
  }
}

function* deleteVessel(action) {
  try {
    yield call(api.delete, `/vessel/${action.id}`)

    yield put({ type: RECEIVE_DELETE_VESSEL })

    const notification = warningMessage(deletedMessage('vessel'))
    yield put({ type: NOTIFY, notification })
  } catch (error) {
    yield put({ type: FAILED_DELETE_VESSEL, error })
  }
}

export default function* root() {
  yield takeLatest(REQUEST_GET_VESSEL, getVessel)
  yield takeLatest(REQUEST_GET_VESSEL_LIST, getVesselList)
  yield takeLatest(REQUEST_GET_VESSELS, getVessels)
  yield takeLatest(REQUEST_PERSIST_VESSEL, persistVessel)
  yield takeLatest(REQUEST_DELETE_VESSEL, deleteVessel)
}
